/**
 * @name: 话术管理
 * @description: 话术管理
 * @author: qq2575896094
 * @time: 2024/9/13
 */

const prefix = '/onlinecs/script'

/**
 * 获取话术列表
 * @type {string}
 */
export const queryScriptList = `${prefix}/queryScriptList`

/**
 * 新增话术
 * @type {string}
 */
export const saveScriptList = `${prefix}/saveScriptList`

/**
 * 修改话术
 * @type {string}
 */
export const modifyScript = `${prefix}/modifyScript`

/**
 * 导入话术
 * @type {string}
 */
export const importScript = `${prefix}/importScript`

/**
 * 下载话术模版
 * @type {string}
 */
export const downloadScriptModel = `${prefix}/downloadScriptModel`

/**
 * 获取类型列表
 * @type {string}
 */
export const queryTypeList = `${prefix}/queryTypeList`
